import { render } from "./LandingPage.vue?vue&type=template&id=c0294b7c&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=c0294b7c&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/checkmarq-backend/checkmarq-backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0294b7c"]])

export default __exports__